/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosInstance } from 'axios';

const refreshToken = async (api: AxiosInstance) => {
  const response = await api({
    method: 'POST',
    url: `auth/refresh-token`,
  });

  return response;
};

const refreshAndRetryQueue: any[] = [];

// Flag to prevent multiple token refresh requests
let isRefreshing = false;

export const refreshTokenInterceptor = async (
  error: any,
  api: AxiosInstance,
) => {
  const originalRequest = error.config;

  if (
    error?.response?.status === 401 &&
    originalRequest?.url?.includes('refresh-token')
  ) {
    refreshAndRetryQueue.length = 0;
    localStorage.clear();

    window.location.href = '/login';

    return null;
  }

  if (error.response && error.response.status === 401) {
    if (!isRefreshing) {
      isRefreshing = true;
      try {
        await refreshToken(api);
        refreshAndRetryQueue.forEach(({ config, resolve, reject }) => {
          api
            .request(config)
            .then((response) => resolve(response))
            .catch((err) => reject(err));
        });

        refreshAndRetryQueue.length = 0;

        return api(originalRequest);
      } finally {
        isRefreshing = false;
      }
    }

    return new Promise((resolve, reject) => {
      refreshAndRetryQueue.push({
        config: originalRequest,
        resolve,
        reject,
      });
    });
  }

  return Promise.reject(error);
};
